// ======================================================================
// File Name       : BackButton
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { isHideBackBtn } from '../utils/SessionStorageUtils';

const BackButton = props =>
  !isHideBackBtn()
    ? <Button {...props}>
      {props.children}
    </Button>
    : <span />;

BackButton.propTypes = Button.propTypes;
BackButton.defaultProps = Button.defaultProps;

export default BackButton;
